export default "__VITE_ASSET__OJldk6zo__"